class TagNotFound extends Error {
    constructor(message) {
        super(message);
        this.name = 'TagNotFound';
    }
}
export default TagNotFound;
